import { render } from "./BlogEditorPage.vue?vue&type=template&id=072d5136&scoped=true&ts=true"
import script from "./BlogEditorPage.vue?vue&type=script&lang=ts"
export * from "./BlogEditorPage.vue?vue&type=script&lang=ts"

import "./BlogEditorPage.vue?vue&type=style&index=0&id=072d5136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072d5136"]])

export default __exports__